import { setLocale } from '@adobe-fonts/site/lib/I18N.js';
import { localizeSharedMessages } from './shared.i18n.js';

export async function switchLocale(locale) {
  const contextualHelpMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/contextual-help/i18n/${locale}.json`);

  const familyCardMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/family-card/i18n/${locale}.json`);

  const fontpackCardMessages = await import(
      /* webpackChunkName: "i18n-[request]" */
      `@adobe-fonts/site/components/fontpack-card/i18n/${locale}.json`);

  const paginationMessages = await import(
    /* webpackChunkName: "i18n-[request]" */
    `@adobe-fonts/site/components/pagination/i18n/${locale}.json`);

  const sharedMessages = await localizeSharedMessages(locale);

  setLocale(locale, {
    ...sharedMessages,
    ...contextualHelpMessages.default,
    ...familyCardMessages.default,
    ...fontpackCardMessages.default,
    ...paginationMessages.default
  });
}
